import { Expose } from "class-transformer";
import { IsBoolean, IsString } from "class-validator";

export class OfficeSettingsRest {
  @IsBoolean()
  @Expose()
  autoAddContractorToAPI!: boolean;
  @IsString()
  @Expose()
  apiIntegrationList!: string;
  @IsString()
  @Expose()
  apiIntegrationListToAutoAdd!: string;
  @IsString()
  @Expose()
  optimaRecipientAccount!: string;
  @IsString()
  @Expose()
  optimaProviderAccount!: string;
}
